export const baseApiUrl = '/api/v1'

export default { baseApiUrl }

